/* eslint-disable @typescript-eslint/no-non-null-assertion */
import i18n from 'i18n';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import React from 'react';
import { Link } from 'react-router-dom';
import LoginDownBar from './components/LoginDownBar';
import styles from './styles';
import ChangeLanguage from 'components/ChangeLanguage';
import { defaultLinks } from 'utils/helpers';
import { connect } from 'react-redux';

const links = [
  defaultLinks[i18n.t('CODE_OF_ETHICS_AND_CONDUCT_KEY')] ||
    defaultLinks['Termos e Condições'],
  defaultLinks[i18n.t('PRIVACY_POLICY_KEY')] ||
    defaultLinks['Política de Privacidade'],
];

export interface LinkButton {
  name: string;
  url: string;
  external?: boolean;
}

interface Props {
  children: React.ReactNode;
  imageWrapper: React.ReactNode;
  logoUrl: string;
  overrideClasses?: any;
  logoBackgroundColor: string;
  config: any;
}

const LoginPage: React.FC<Props> = ({
  children,
  imageWrapper,
  logoUrl,
  overrideClasses,
  logoBackgroundColor,
  config,
}) => {
  const theme = useTheme();

  const classes = makeStyles(
    styles(theme, overrideClasses, logoBackgroundColor, config?.backgroundColor)
  )();

  return (
    <Grid container className={classes.root}>
      <Hidden mdDown>
        <Grid
          container
          item
          lg={12}
          className={classes.appBar}
          justifyContent="space-between"
        >
          <Grid item className={classes.logoWrapper}>
            <Link to="/" className={classes.hrefLogoWrapper}>
              <img
                src={logoUrl}
                alt="Logo"
                className={classes.logo}
                width={150}
              />
            </Link>
          </Grid>
          <Grid item className={classes.languageWrapper}>
            <ChangeLanguage />
          </Grid>
        </Grid>
      </Hidden>

      {imageWrapper}

      <Grid
        className={classes.loginContainer}
        alignContent="space-between"
        justifyContent="center"
      >
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className={classes.loginWrapper}
        >
          <Grid container className={classes.children}>
            {children}
          </Grid>
        </Grid>
        <div
          className="g-recaptcha"
          data-sitekey={process.env.REACT_APP_RECAPTCHA_KEY!}
          data-callback="onSubmit"
          data-size="invisible"
          data-badge="bottomleft"
        ></div>

        <Grid
          container
          item
          xs={12}
          className={classes.copyrightWrapper}
          alignContent="center"
          alignItems="center"
        >
          <LoginDownBar links={links} />
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ config }) => ({
  config,
});

export default withWidth()(connect(mapStateToProps)(LoginPage));
